import React from "react";
import Style from "./index.module.scss";
import classNames from "classnames";

interface Props {
    children: React.ReactChild;
    title: string;
    className?: string;
}
const Index = ({ title, children, className }: Props) => {
    return (
        <div className={classNames(Style.root, className)}>
            <div className={Style.title}>{title}</div>
            <div>{children}</div>
        </div>
    );
};

export default Index;
